import React from 'react';
import { DesignTokens, GivelifyLabel } from '@givelify/ui';
import { Envelope } from 'api/models';
import * as ReactSortableHOC from 'react-sortable-hoc';
import { useEnvelopesContext } from '../../context/EnvelopesProvider';
import EnvelopeListItemIcon from './EnvelopeListItemIcon';
import { DragZoneMobile, TitleWrapper, Wrapper } from './styles';

const ActiveEnvelopeListItemHandle = ReactSortableHOC.SortableHandle<{
    children: React.ReactNode;
}>((props) => <DragZoneMobile {...props} />);

const EnvelopeMobileSortItem: React.FCC<Envelope> = (props) => {
    const { active, name } = props;

    const { updatePrioritiesRequestState, movedItemId } = useEnvelopesContext();
    const itemIsMoved = movedItemId === props.id;
    const isMoving = updatePrioritiesRequestState === 'REQUEST_START';
    const otherItemIsMoving = !itemIsMoved && isMoving;

    return (
        <Wrapper
            mobile
            active={active}
            aria-label="Active envelope"
            test-id={name}
        >
            <ActiveEnvelopeListItemHandle>
                <EnvelopeListItemIcon active={active} id={props.id} />
                <TitleWrapper>
                    <GivelifyLabel
                        wordBreak
                        wrap
                        color={
                            (!active || otherItemIsMoving) &&
                            DesignTokens.color.textDisabled
                        }
                        id={`envelope-name-${props.id}`}
                        text={name}
                        variant="heading3S"
                    />
                </TitleWrapper>
            </ActiveEnvelopeListItemHandle>
        </Wrapper>
    );
};

export default EnvelopeMobileSortItem;
